var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"8","width":"1","height":"10","transform":"rotate(45 8 0)","fill":"#009D4F","key":0}),React.createElement("rect",{"x":"1","y":"1","width":"1","height":"10","transform":"rotate(-45 1 1)","fill":"#009D4F","key":1})]);
}

Close.defaultProps = {"width":"9","height":"9","viewBox":"0 0 9 9","fill":"none"};

module.exports = Close;

Close.default = Close;
